import React from "react";
import { Link } from "react-router-dom";
import whapsappLogo from "../../assets/whatsapp-icon-logo-svgrepo-com.svg";
import facebookLogo from "../../assets/facebook-color-svgrepo-com.svg";
import instagramLogo from "../../assets/instagram-1-svgrepo-com.svg";
import tryMeals from "../../assets/tray-meal-svgrepo-com.svg";

//Home page
export const Home = () => {
  return (
    <div
      className={` w-full min-h-screen flex justify-center items-center bg-black bg-logo-pattern bg-repeat bg-[length:80px_80px]  text-white overflow-y-hidden `}
    >
      <span className=" flex flex-col w-[70%] max-w-[500px] mt-5 mb-5 items-center bg-white bg-opacity-50 rounded-2xl pb-3">
        <Link className=" flex flex-col w-min items-center mt-5" to="/menu">
          <img
            className=" w-[100%]"
            loading="lazy"
            src={tryMeals}
            alt="Menu page"
          />
          <span className=" text-black font-bold text-4xl">Menú</span>
        </Link>
        <Link
          className=" flex flex-col w-min items-center mt-5"
          to="https://www.facebook.com/profile.php?id=61560525298032&mibextid=ZbWKwL"
        >
          <img
            className=" w-[40%]"
            loading="lazy"
            src={facebookLogo}
            alt="Facebook page"
          />
          <span className=" text-black font-bold text-4xl">Facebook</span>
        </Link>
        <Link
          className=" flex flex-col w-min items-center mt-5"
          to="https://www.instagram.com/taweno_santarrosa?igsh=MWF2d3dpY2F4ZDF3MA=="
        >
          <img
            className=" w-[40%]"
            loading="lazy"
            src={instagramLogo}
            alt="Instagram page"
          />
          <span className=" text-black font-bold text-4xl">Instagram</span>
        </Link>
        <Link
          className=" flex flex-col w-min items-center mt-5"
          to="https://wa.me/573006395234"
        >
          <img
            className=" w-[40%]"
            loading="lazy"
            src={whapsappLogo}
            alt="Whapsapp contact"
          />
          <span className=" text-black font-bold text-4xl">Whatsapp</span>
        </Link>
      </span>
    </div>
  );
};
